import { asyncActionCreators } from '../../utils/actions';

export const fetchBills = asyncActionCreators("Bills/FETCH_BILLS");




// WEBPACK FOOTER //
// ./src/sagas/bills/actions.js